import styled, { css } from 'styled-components';
import { exFont } from '../../shared/typography';
import Pill from '../../shared/ui/Pill';
import { Card, StepColumn } from '../QuestionsStep/style';

export const MarkingColumn = styled(StepColumn)`
  max-width: 912px;
  gap: 14px;
  & > :first-child {
    gap: 6px;
    h2 {
      line-height: normal;
    }
    p {
      font-size: 14.5px;
      line-height: normal;
    }
  }
  & > section:first-of-type {
    padding: 14px 20px;
  }
`;

export const MarkingCard = styled(Card)`
  position: relative;
  gap: 18px;
  padding-left: 20px;
  padding-right: 20px;
  & > p {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: -4px;
  }
`;

// Marking step (tplA 585–763). Form primitives are shared with Questions.
export * from '../QuestionsStep/style';

export const TotalRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  & > span:first-child,
  label {
    font-size: 16px;
  }
  input {
    box-sizing: border-box;
    width: 76px;
    height: 50px;
    border-radius: 12px;
    font-size: 22px;
    font-weight: 700;
  }
`;

export const TotalValue = styled.span`
  ${exFont(700, 'xxl')}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 50px;
  border-radius: var(--ex-radius-card);
  background: #f3f0f8;
  color: var(--ex-ink);
`;

export const TipCard = styled.div`
  position: absolute;
  z-index: 2;
  top: 57px;
  left: 95px;
  width: min(340px, calc(100% - 40px));
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 18px 14px;
  border-radius: var(--ex-radius-card);
  background: var(--ex-ink);
  box-shadow: 0 14px 36px rgba(37, 34, 42, 0.28);
  &::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 32px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid var(--ex-ink);
  }
  button:not([data-testid]),
  span {
    color: var(--white);
  }
  p {
    ${exFont(400, 's')}
    font-size: 13.5px;
    line-height: 1.5;
    margin: 0;
    color: var(--white);
  }
  & > div:first-child + p {
    margin-top: 2px;
  }
`;

export const TipHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  p {
    ${exFont(700, 'm')}
    font-size: 15px;
    line-height: normal;
    flex: 1;
  }
  button {
    width: 16px;
    height: 16px;
  }
`;

export const TipFoot = styled.div`
  > button:last-child {
    background: var(--white);
    border-color: var(--white);
    color: var(--ex-purple);
    min-height: 34px;
    padding: 0 16px;
    font-size: 13.5px;
  }
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 4px;
  margin: -20px -20px 0;
  padding: 0 12px;
  overflow-x: auto;
  border-bottom: 1px solid var(--ex-line);
`;

export const Tab = styled.button`
  ${exFont(600, 's')}
  font-size: 15px;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 14px 12px 12px;
  border: none;
  border-bottom: 2px solid
    ${({ $active }) => ($active ? 'var(--ex-purple)' : 'transparent')};
  background: none;
  color: ${({ $active }) => ($active ? 'var(--ex-purple)' : 'var(--ex-ink-2)')};
  cursor: pointer;
`;

export const TabNote = styled.span`
  ${exFont(400, 'xs')}
  font-size: 12.5px;
  color: var(--ex-ink-muted);
`;

export const UnseenDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--ex-purple);
`;

export const RowList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ToolRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 64px;
  box-sizing: border-box;
  padding: 12px 16px;
  border: 1px solid
    ${({ $suggested }) =>
      $suggested ? 'var(--ex-purple-200)' : 'var(--ex-line)'};
  border-radius: var(--ex-radius-card);
  background: ${({ $suggested }) =>
    $suggested ? 'var(--ex-surface-tint)' : 'var(--ex-surface)'};
  & > button:last-child {
    min-height: 38px;
  }
`;

export const RowLabel = styled.span`
  ${exFont(700, 's')}
  font-size: 15px;
  flex: 0 0 48px;
  color: var(--ex-ink);
`;

export const RowMain = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const RowTitle = styled.p`
  ${exFont(600, 's')}
  font-size: 14px;
  line-height: normal;
  margin: 0;
  color: var(--ex-ink);
`;

export const RowMeta = styled.p`
  ${exFont(400, 'xs')}
  font-size: 13px;
  line-height: normal;
  margin: 0;
  color: var(--ex-ink-muted);
`;

export const RowIssue = styled.p`
  ${exFont(500, 'xs')}
  margin: 2px 0 0;
  color: ${({ $advisory }) =>
    $advisory ? 'var(--ex-warn-ink)' : 'var(--ex-bad-ink)'};
`;

// ------------------------------------------------------------------- modal
export const Grow = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ModalScrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--ex-scrim);
`;

export const ModalCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $wide, $variant }) => {
    if ($variant === 'criteria') return $wide ? '1120px' : '760px';
    if ($variant === 'feedback') return '620px';
    if ($variant === 'preview') return '720px';
    if ($variant === 'criteriaPreview') return '480px';
    return $wide ? '1040px' : '640px';
  }};
  min-height: 0;
  max-height: calc(100vh - 48px);
  background: var(--ex-surface);
  border-radius: ${({ $variant }) =>
    $variant ? '16px' : 'var(--ex-radius-card)'};
  box-shadow: var(--ex-shadow-modal);
  ${({ $variant }) =>
    $variant &&
    css`
      overflow: hidden;
    `}
  &:focus {
    outline: none;
  }
`;

export const ModalHead = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 24px 12px;
  h3 {
    ${exFont(700, 'xl')}
    margin: 0;
    color: var(--ex-ink);
  }
  p {
    ${exFont(400, 's')}
    margin: 4px 0 0;
    color: var(--ex-ink-2);
  }
  ${({ $variant }) =>
    $variant &&
    css`
      flex: 0 0 auto;
      h3 {
        font-size: ${$variant === 'preview' ? '20px' : '19px'};
        line-height: normal;
      }
      p {
        margin-top: 3px;
        font-size: 13px;
        font-weight: 500;
        line-height: normal;
        color: var(--ex-ink-muted);
      }
      > button {
        width: 20px;
        height: 20px;
        padding: 0;
      }
    `}
  ${({ $variant }) =>
    ['criteria', 'feedback'].includes($variant) &&
    css`
      align-items: center;
      padding: 18px 24px;
      border-bottom: 1px solid var(--ex-line);
    `}
  ${({ $variant }) =>
    $variant === 'preview' &&
    css`
      padding: 20px 24px 4px;
    `}
  ${({ $variant }) =>
    $variant === 'criteriaPreview' &&
    css`
      padding: 20px 24px 6px;
    `}
`;

export const ModalEyebrow = styled.p`
  && {
    margin: 0 0 2px;
    font: 600 11.5px var(--ex-font-family);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--ex-ink-muted);
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 8px 24px 16px;
  overflow: auto;
  ${({ $variant }) =>
    $variant &&
    css`
      flex: 1 1 auto;
      min-height: 0;
      padding: 18px 24px;
    `}
  ${({ $variant }) =>
    $variant === 'criteria' &&
    css`
      gap: 16px;
    `}
  ${({ $variant }) =>
    $variant === 'preview' &&
    css`
      padding: 14px 24px 8px;
    `}
  ${({ $variant }) =>
    $variant === 'criteriaPreview' &&
    css`
      padding: 12px 24px 8px;
      gap: 0;
    `}
  ${({ $variant }) =>
    $variant === 'feedback' &&
    css`
      label {
        font-size: 13.5px;
      }
      input:not([type='file']) {
        height: 38px;
        padding: 0 10px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 400;
      }
    `}
`;

export const ModalFoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 24px;
  border-top: 1px solid var(--ex-line);
  ${({ $variant }) =>
    $variant &&
    css`
      flex: 0 0 auto;
      gap: 12px;
      > button:not(:first-child),
      > button:only-child {
        min-height: 44px;
        padding: 0 26px;
        font-size: 15px;
        font-weight: 600;
        box-shadow: none;
      }
    `}
  ${({ $variant }) =>
    $variant === 'feedback' &&
    css`
      gap: 10px;
      padding-bottom: 18px;
      > button:not(:first-child) {
        padding: 0 20px;
      }
    `}
  ${({ $variant }) =>
    $variant === 'preview' &&
    css`
      padding-bottom: 20px;
      border-top: none;
      > button:only-child {
        padding: 13px 28px;
        line-height: normal;
      }
    `}
`;

export const CriteriaSourceRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  > button:first-child {
    min-height: 40px;
    padding: 0 18px;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const SourcePickerRoot = styled.div`
  position: relative;
  flex: 1;
  min-width: 220px;
  select {
    width: 100%;
    height: 40px;
    padding: 0 ${({ $suggested }) => ($suggested ? '170px' : '36px')} 0 12px;
    font-size: 14px;
    font-weight: 500;
  }
  > span {
    position: absolute;
    top: 50%;
    right: 38px;
    transform: translateY(-50%);
    pointer-events: none;
    font-size: 11.5px;
    font-weight: 600;
    padding: 3px 10px;
  }
`;

export const PickGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
`;

export const PickCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${({ $dashed }) => ($dashed ? '8px' : '10px')};
  padding: 22px 18px;
  border: ${({ $dashed }) => ($dashed ? '1.5px dashed' : '1px solid')}
    ${({ $over, $dashed }) =>
      $over ? 'var(--ex-purple)' : $dashed ? '#c9bff0' : 'var(--ex-line)'};
  border-radius: var(--ex-radius-card);
  background: ${({ $over }) =>
    $over ? 'var(--ex-purple-100)' : 'var(--ex-surface)'};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  & > select {
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 500;
  }
  p {
    ${exFont(400, 's')}
    margin: 0;
    color: var(--ex-ink-2);
  }
`;

export const PickIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: ${({ $upload }) =>
    $upload ? 'var(--ex-purple-100)' : 'var(--ex-surface-2)'};
  color: ${({ $upload }) =>
    $upload ? 'var(--ex-purple)' : 'var(--ex-ink-strong)'};
`;

export const PickActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  & > button:first-child {
    width: 100%;
    min-height: 40px;
    background: var(--ex-surface);
    border: 1.5px solid var(--ex-purple);
    color: var(--ex-purple);
    font-size: 14px;
    font-weight: 600;
  }
`;

export const PickTitle = styled.p`
  && {
    ${exFont(600, 15)}
    color: var(--ex-ink);
  }
`;

export const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border-radius: var(--ex-radius-card);
  background: var(--ex-surface-2);
`;

export const StepLine = styled.div`
  ${exFont(500, 's')}
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${({ $state }) =>
    $state === 'pending' ? 'var(--ex-ink-faint)' : 'var(--ex-ink)'};
`;

export const PreviewHead = styled.div`
  min-height: 34px;
  display: flex;
  align-items: center;
  gap: 10px;
  span:first-child {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--ex-ink-muted);
  }
`;

export const PreviewEditButton = styled(Pill)`
  min-height: 34px;
  padding: 0 16px;
  border: 1.5px solid var(--ex-purple);
  color: var(--ex-purple);
  font-size: 13.5px;
  font-weight: 600;
`;

// ------------------------------------------------------------------ editors
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  ${({ $columns, $editing }) =>
    $columns &&
    css`
      min-width: ${110 + $columns * 200 + ($editing ? 56 : 0)}px;
    `}
  th,
  td {
    padding: ${({ $editing }) => ($editing ? '8px 10px' : '11px 14px')};
    border-bottom: 1px solid var(--ex-line);
    vertical-align: top;
    text-align: left;
    font-size: 14px;
    line-height: 1.5;
    color: var(--ex-ink-strong);
  }
  tbody tr:last-child td {
    border-bottom: none;
  }
  tbody td:first-child {
    font-size: 15px;
    font-weight: 700;
    color: var(--ex-ink);
  }
  th {
    padding: 10px 14px;
    background: #fbfafd;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--ex-ink-muted);
  }
  ${({ $columns }) =>
    $columns &&
    css`
      th button,
      td:first-child button {
        flex: 0 0 auto;
        width: 26px;
        height: 26px;
        padding: 0;
        border: 1px solid var(--ex-line);
        border-radius: 7px;
      }
      th:not(:first-child) {
        font-size: 13.5px;
        font-weight: 700;
        letter-spacing: normal;
        text-transform: none;
        color: var(--ex-royal);
      }
    `}
  ${({ $columns, $editing }) =>
    $columns &&
    $editing &&
    css`
      th:last-child button {
        width: 34px;
        height: 34px;
        border: 1.5px dashed var(--ex-purple);
        border-radius: var(--ex-radius-pill);
        color: var(--ex-purple);
      }
    `}
`;

export const GridScroll = styled.div`
  flex: 0 0 auto;
  overflow-x: auto;
  border: 1px solid var(--ex-line);
  border-radius: 12px;
`;

export const CellText = styled.textarea`
  font: 400 14px/1.45 var(--ex-font-family);
  box-sizing: border-box;
  width: 100%;
  min-height: 48px;
  padding: 8px 10px;
  border: 1px solid
    ${({ $invalid }) => ($invalid ? 'var(--ex-bad)' : 'var(--ex-line-strong)')};
  border-radius: 8px;
  resize: vertical;
  color: var(--ex-ink);
  &:focus {
    outline: none;
    border-color: var(--ex-purple);
  }
`;

export const PointsInput = styled.input`
  ${exFont(500, 'xs')}
  box-sizing: border-box;
  width: 44px;
  padding: 4px;
  text-align: center;
  border: 1px solid
    ${({ $invalid }) => ($invalid ? 'var(--ex-bad)' : 'var(--ex-line-strong)')};
  border-radius: 6px;
  &:focus {
    outline: none;
    border-color: var(--ex-purple);
  }
`;

export const PointsRow = styled.div`
  ${exFont(500, 'xs')}
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  color: var(--ex-ink-muted);
`;

export const HeadInput = styled.input`
  font: 700 13.5px/1.3 var(--ex-font-family);
  color: inherit;
  box-sizing: border-box;
  flex: 1;
  width: 0;
  min-width: 0;
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--ex-line-strong);
  border-radius: 6px;
  &:focus {
    outline: none;
    border-color: var(--ex-purple);
  }
`;

export const SumLine = styled.p`
  ${exFont(600, 's')}
  margin: 0;
  color: ${({ $ok }) => ($ok ? 'var(--ex-ok-ink)' : 'var(--ex-warn-ink)')};
`;

export const OwnCancelButton = styled(Pill)`
  background: var(--ex-surface);
  border: 1px solid var(--ex-purple);
  color: var(--ex-purple);
`;

export const OwnGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid var(--ex-line);
  border-radius: 12px;
  > div:first-child {
    flex-wrap: nowrap;
    input {
      flex: 1;
      width: 0;
      min-width: 0;
      font-weight: 600;
    }
    button {
      flex: 0 0 auto;
      width: 15px;
      height: 15px;
      padding: 0;
    }
  }
  > div:last-child {
    margin-left: 14px;
  }
`;

export const OwnItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 14px;
  > span {
    color: #b9b5c0;
  }
  input {
    flex: 1;
    width: 0;
    min-width: 0;
  }
`;

// ---------------------------------------------------------------- feedback
export const TypeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  flex-wrap: wrap;
  border-top: 1px solid var(--ex-line);
  &:first-child {
    border-top-color: transparent;
  }
  > span:first-child {
    ${exFont(500, 14.5)}
  }
  [role='radiogroup'] {
    padding: 3px;
    gap: 0;
    border: 1px solid var(--ex-line-strong);
    border-radius: 999px;
    background: white;
  }
  [role='radio'] {
    ${exFont(600, 13)}
    padding: 6px 16px;
    border-radius: 999px;
    box-shadow: none;
  }
  [role='radio'][aria-checked='true'] {
    color: white;
    background: var(--ex-purple);
    box-shadow: none;
  }
`;

export const TypeQuestion = styled.span`
  ${exFont(600, 'm')}
  flex: 1;
  min-width: 220px;
  color: var(--ex-ink);
`;

export const ConfigBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 0 12px;
`;

export const ConfigRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 8px 12px;
  border-radius: var(--ex-radius-item);
  background: var(--ex-surface-2);
  ${({ $excluded }) =>
    $excluded &&
    css`
      opacity: 0.6;
    `}
`;

export const Tick = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 5px;
  border: 1px solid
    ${({ $on }) => ($on ? 'var(--ex-purple)' : 'var(--ex-line-strong)')};
  background: ${({ $on }) => ($on ? 'var(--ex-purple)' : 'var(--ex-surface)')};
  color: var(--white);
  cursor: pointer;
`;

export const ChipRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const ScChipRoot = styled.span`
  ${exFont(500, 'xs')}
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 6px 4px 10px;
  border-radius: var(--ex-radius-pill);
  border: 1px solid var(--ex-purple-200);
  background: var(--ex-surface);
  color: var(--ex-ink);
  cursor: grab;
  touch-action: none;
`;

export const Popover = styled.div`
  position: absolute;
  z-index: 30;
  top: calc(100% + 6px);
  left: 0;
  width: 300px;
  max-height: 320px;
  overflow: auto;
  padding: 8px;
  background: var(--ex-surface);
  border: 1px solid var(--ex-line);
  border-radius: var(--ex-radius-card);
  box-shadow: var(--ex-shadow-3);
`;

export const PopoverItem = styled.button`
  ${exFont(400, 's')}
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: var(--ex-radius-item);
  background: none;
  text-align: left;
  color: var(--ex-ink);
  cursor: pointer;
  &:hover {
    background: var(--ex-surface-tint);
  }
`;

export const Relative = styled.span`
  position: relative;
  display: inline-flex;
`;

export const Accordion = styled.div`
  border-top: 1px solid var(--ex-line);
  padding-top: 16px;
`;

export const AccordionHead = styled.button`
  ${exFont(600, 15)}
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  text-align: left;
  color: var(--ex-ink);
  cursor: pointer;
`;

export const AccordionBody = styled.div`
  padding: 12px 0 16px;
`;

export const Sample = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border-radius: var(--ex-radius-card);
  background: var(--ex-surface-2);
  p {
    ${exFont(400, 's')}
    margin: 0;
    color: var(--ex-ink);
  }
`;

export const Caps = styled.p`
  && {
    ${exFont(600, 'xs')}
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--ex-ink-2);
  }
`;

export const Highlight = styled.span`
  background: var(--ex-warn-bg);
`;

// ------------------------------------------------------------------ extras
export const SectionTitle = styled.p`
  ${exFont(700, 'm')}
  margin: 0;
  color: var(--ex-ink);
`;

export const DropZone = styled.div`
  ${exFont(400, 's')}
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px dashed
    ${({ $over }) => ($over ? 'var(--ex-purple)' : 'var(--ex-purple-200)')};
  border-radius: var(--ex-radius-card);
  background: ${({ $over }) =>
    $over ? 'var(--ex-purple-100)' : 'var(--ex-surface-tint)'};
  color: var(--ex-ink-2);
  cursor: pointer;
  > svg {
    box-sizing: content-box;
    width: 20px;
    height: 20px;
    padding: 10px;
    border-radius: 10px;
    color: var(--ex-purple);
    background: var(--ex-purple-100);
  }
  > div > p:first-child {
    margin: 0 0 4px;
    color: var(--ex-ink);
    font-weight: 600;
  }
`;

export const ExemplarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  & + & {
    border-top: 1px solid var(--ex-line);
  }
`;

export const ExemplarName = styled.span`
  ${exFont(500, 's')}
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--ex-ink);
`;
